import { render, staticRenderFns } from "./NotificationsDetailView.vue?vue&type=template&id=c7e7b1c4&scoped=true"
import script from "./NotificationsDetailView.vue?vue&type=script&lang=js"
export * from "./NotificationsDetailView.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDetailView.vue?vue&type=style&index=0&id=c7e7b1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e7b1c4",
  null
  
)

export default component.exports